export default __webpack_public_path__ + "static/media/tefera.186de71c.jpg";